var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerAnimationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(241, 242, 243)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "450px",
    height: "450px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.950091575091575s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4.285714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.9386446886446886s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8.571428571428571 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.9271978021978022s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12.857142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.9157509157509157s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(17.142857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.9043040293040293s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.428571428571427 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8928571428571429s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(25.714285714285715 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8814102564102564s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.86996336996337s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(34.285714285714285 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8585164835164836s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38.57142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8470695970695971s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(42.857142857142854 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8356227106227107s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(47.142857142857146 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8241758241758241s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8127289377289377s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.714285714285715 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.8012820512820513s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7898351648351648s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(64.28571428571429 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7783882783882784s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(68.57142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.766941391941392s",
    repeatCount: "indefinite"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7554945054945055s",
    repeatCount: "indefinite"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(77.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7440476190476191s",
    repeatCount: "indefinite"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(81.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7326007326007326s",
    repeatCount: "indefinite"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(85.71428571428571 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7211538461538461s",
    repeatCount: "indefinite"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.7097069597069597s",
    repeatCount: "indefinite"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(94.28571428571429 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6982600732600732s",
    repeatCount: "indefinite"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(98.57142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6868131868131868s",
    repeatCount: "indefinite"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6753663003663004s",
    repeatCount: "indefinite"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(107.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6639194139194139s",
    repeatCount: "indefinite"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(111.42857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6524725274725275s",
    repeatCount: "indefinite"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(115.71428571428571 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6410256410256411s",
    repeatCount: "indefinite"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6295787545787546s",
    repeatCount: "indefinite"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(124.28571428571429 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6181318681318682s",
    repeatCount: "indefinite"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(128.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.6066849816849816s",
    repeatCount: "indefinite"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(132.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5952380952380952s",
    repeatCount: "indefinite"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(137.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5837912087912088s",
    repeatCount: "indefinite"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(141.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5723443223443223s",
    repeatCount: "indefinite"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(145.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5608974358974359s",
    repeatCount: "indefinite"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5494505494505495s",
    repeatCount: "indefinite"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.538003663003663s",
    repeatCount: "indefinite"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(158.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5265567765567766s",
    repeatCount: "indefinite"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(162.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5151098901098902s",
    repeatCount: "indefinite"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(167.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.5036630036630036s",
    repeatCount: "indefinite"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(171.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.49221611721611724s",
    repeatCount: "indefinite"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(175.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.4807692307692308s",
    repeatCount: "indefinite"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.4693223443223443s",
    repeatCount: "indefinite"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(184.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.45787545787545786s",
    repeatCount: "indefinite"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(188.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.44642857142857145s",
    repeatCount: "indefinite"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(192.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.434981684981685s",
    repeatCount: "indefinite"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(197.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.42353479853479853s",
    repeatCount: "indefinite"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(201.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.41208791208791207s",
    repeatCount: "indefinite"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.40064102564102566s",
    repeatCount: "indefinite"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.3891941391941392s",
    repeatCount: "indefinite"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(214.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.37774725274725274s",
    repeatCount: "indefinite"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(218.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.3663003663003663s",
    repeatCount: "indefinite"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(222.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.35485347985347987s",
    repeatCount: "indefinite"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(227.14285714285714 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.3434065934065934s",
    repeatCount: "indefinite"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(231.42857142857142 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.33195970695970695s",
    repeatCount: "indefinite"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(235.71428571428572 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.32051282051282054s",
    repeatCount: "indefinite"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.3090659340659341s",
    repeatCount: "indefinite"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(244.28571428571428 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.2976190476190476s",
    repeatCount: "indefinite"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(248.57142857142858 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.28617216117216115s",
    repeatCount: "indefinite"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252.85714285714286 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.27472527472527475s",
    repeatCount: "indefinite"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.2632783882783883s",
    repeatCount: "indefinite"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(261.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.2518315018315018s",
    repeatCount: "indefinite"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(265.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.2403846153846154s",
    repeatCount: "indefinite"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.22893772893772893s",
    repeatCount: "indefinite"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(274.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.2174908424908425s",
    repeatCount: "indefinite"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(278.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.20604395604395603s",
    repeatCount: "indefinite"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(282.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.1945970695970696s",
    repeatCount: "indefinite"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(287.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.18315018315018314s",
    repeatCount: "indefinite"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(291.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.1717032967032967s",
    repeatCount: "indefinite"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(295.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.16025641025641027s",
    repeatCount: "indefinite"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.1488095238095238s",
    repeatCount: "indefinite"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.13736263736263737s",
    repeatCount: "indefinite"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.1259157509157509s",
    repeatCount: "indefinite"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(312.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.11446886446886446s",
    repeatCount: "indefinite"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(317.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.10302197802197802s",
    repeatCount: "indefinite"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(321.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.09157509157509157s",
    repeatCount: "indefinite"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(325.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.08012820512820513s",
    repeatCount: "indefinite"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.06868131868131869s",
    repeatCount: "indefinite"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(334.2857142857143 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.05723443223443223s",
    repeatCount: "indefinite"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.57142857142856 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.045787545787545784s",
    repeatCount: "indefinite"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(342.85714285714283 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.034340659340659344s",
    repeatCount: "indefinite"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(347.14285714285717 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.022893772893772892s",
    repeatCount: "indefinite"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(351.42857142857144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "-0.011446886446886446s",
    repeatCount: "indefinite"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(355.7142857142857 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36.5,
    rx: 14.1,
    ry: 0.5,
    width: 30,
    height: 1,
    fill: "#f6d463"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9615384615384615s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerAnimationSmall);
export default __webpack_public_path__ + "static/media/spinner-animation-small.35776334dd330998d77bf6615d269da7.svg";
export { ForwardRef as ReactComponent };